export default __webpack_public_path__ + "static/media/searchicon.0e7b52b8.svg";